import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { OutsideClickHandler } from '../../components';
import { IoIosArrowDown } from 'react-icons/io';

import css from './LanguageDropdown.css';

class LanguageDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.selectLanguage = this.selectLanguage.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  toggleDropdown() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  }

  selectLanguage(language) {
    const { onChange } = this.props;
    this.setState({ isOpen: false });
    if (onChange) {
      onChange({ target: { value: language } });
    }
  }

  handleOutsideClick() {
    this.setState({ isOpen: false });
  }

  render() {
    const { className, currentLanguage, languages } = this.props;
    const { isOpen } = this.state;

    const classes = classNames(css.root, className);
    const dropdownClasses = classNames(css.dropdown, {
      [css.dropdownOpen]: isOpen,
    });

    const currentLang = languages.find(lang => lang.value === currentLanguage) || languages[0];

    return (
      <OutsideClickHandler onOutsideClick={this.handleOutsideClick}>
        <div className={classes}>
          <button
            type="button"
            className={css.trigger}
            onClick={this.toggleDropdown}
            aria-expanded={isOpen}
            aria-haspopup="listbox"
          >
            <span className={css.triggerText}>{currentLang.label}</span>
            <span className={classNames(css.arrow, { [css.arrowOpen]: isOpen })}>
              <IoIosArrowDown />
            </span>
          </button>

          <div className={dropdownClasses} role="listbox">
            {languages.map(language => (
              <button
                key={language.value}
                type="button"
                className={classNames(css.option, {
                  [css.optionActive]: language.value === currentLanguage,
                })}
                onClick={() => this.selectLanguage(language.value)}
                role="option"
                aria-selected={language.value === currentLanguage}
              >
                {language.label}
              </button>
            ))}
          </div>
        </div>
      </OutsideClickHandler>
    );
  }
}

LanguageDropdown.defaultProps = {
  className: null,
  currentLanguage: 'fi',
  languages: [
    { value: 'en', label: 'EN' },
    { value: 'fi', label: 'FI' },
  ],
};

LanguageDropdown.propTypes = {
  className: PropTypes.string,
  currentLanguage: PropTypes.string,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  onChange: PropTypes.func,
};

export default LanguageDropdown;
